import React from 'react';
import loadable from '@loadable/component';

/**
 * @name AsyncModuleLoader
 * @param loader - function that calls a dynamic import() for a module with a default export containing a React component
 * @param loading - react component to be rendered as a fallbak while the lazy component is loading
 * @returns returns a functional module containing a React component
 */

const AsyncModuleLoader = ({
    loader,
    loading
}) => {
    if (typeof window === 'undefined') {
        return () => null;
    }

    const LazyComponent = loadable(loader);

    return function LazyLoadedComponent(props) {
        return <LazyComponent { ...props } fallback={ loading } />;
    };
};

export default AsyncModuleLoader;
